import ApiService from './api.service'

export type OnboardingStage = 'COMPANY_REQUIRED' | 'TRIAL_ACTIVE' | 'PAYMENT_PENDING' | 'ACTIVE' | 'PLAN_REQUIRED'

export interface OnboardingStatus {
  stage: OnboardingStage
  canAccessWorkspace: boolean
  firmId?: number
  subscriptionId?: number
  planType?: 'TRIAL' | 'FREE' | 'PAID' | 'ENTERPRISE'
  subscriptionStatus?: string
  trialEndsOn?: string
  remainingTrialDays: number
  pendingOrderId?: number
}

export interface CompanyRequest { name: string; address: string; phone: string; currency: string }
export interface PlanRequest { planId: number; billingPeriod: 'MONTHLY' | 'ANNUAL'; paymentMethod: string }
export interface PlanResponse { stage: OnboardingStage; orderId?: number; paymentUrl?: string; paymentReference?: string }

class OnboardingService extends ApiService {
  async status(): Promise<OnboardingStatus> {
    return await this.get('/api/onboarding/status') as OnboardingStatus
  }
  async createCompany(data: CompanyRequest): Promise<OnboardingStatus> {
    return await this.post('/api/onboarding/company', data) as OnboardingStatus
  }
  async selectPlan(data: PlanRequest): Promise<PlanResponse> {
    return await this.post('/api/onboarding/plan', data) as PlanResponse
  }
}

export default new OnboardingService()
